
export const getSelectOptions = (fieldName, config = {}) => {
  const fieldConfig = config[fieldName];

  if (!fieldConfig) return [];

  const { list = [], valueKey, labelKey } = fieldConfig;

  if (!Array.isArray(list)) return [];

  return list.map(item => ({
    value: item[valueKey],
    label: item[labelKey]
  }));
};